// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b89c9f89","732":"47b693dd","977":"3c9e22da"}[chunkId] + ".chunk.js";
};